// extracted by mini-css-extract-plugin
module.exports = {"page":"CertifyEmail_page_3zHYe","goBack":"CertifyEmail_goBack_1Rtty","action_btn":"CertifyEmail_action_btn_1sKBE"};